// Put your application javascript here
const store = Vue.reactive({
  state: {
    products: [],
    selected: [],
  },

  getProducts() {
    console.log("loading products...");
    axios
      .get(`/collections/retail-meals?view=custom-collection-json`)
      // changes 28-oct
      // .get(
      //   `/collections/general-wellness?view=custom-collection-json`
      // )
      .then((res) => {
        console.log(res);
        if (res.data && res.data.products) {
          this.state.products = res.data.products;
          console.log(`Products loaded!`);
        }
      });
  },
});

if (document.querySelector("#meals-checkout-app")) {
  const app = Vue.createApp({
    template: /*html*/ `

    <div class="flex flex-col lg:flex-row w-full justify-center"  v-if="currentTab == 'Meals'">
   <div class="border-r-[2px] border-r-[#F8F8F1] w-full">
      <div class="bg-[#deedbf] min-h-[3rem]  z-[1029] flex items-center justify-center mt-[40px] !hidden"
         style="border-bottom: 1px solid #fff">
         <ol class="flex w-full justify-center gap-4">
            <li class="m-0">
               <a href="#" class="text-[1.125rem] leading-[1.125rem] tracking-normal font-extrabold">Meals</a>
            </li>
            <li class="m-0"> 
               <a href="#" class="text-[#666] text-[1.125rem] leading-[1.125rem] tracking-normal font-medium"
                  >Checkout</a>
            </li>
         </ol>
      </div>
      <div>
         <div class="fixed inset-0 transition-opacity  duration-500 z-[100] ease-in-out bg-gray-500 bg-opacity-75 opacity-0 opacity-100 cursor-pointer dull-bg md:duration-300"
            :class="{'hidden': !slideCartOpen,'block': slideCartOpen,}" @click="closeSlideCart">
         </div>
         <div
   class="cartwrapper-3 h-screen  fixed   !top-[0px] !right-0 z-[100]   bg-transparent transition duration-500 md:duration-300 ease-in-out transform  pointer-events-auto py-[28px] pr-[20px]"
   id="cartWrapper" :class="{'translate-x-[700px]': !slideCartOpen, 'translate-x-[0px]': slideCartOpen, }">
   <div class="w-full h-full bg-white rounded-[8px] overflow-hidden">
      <div class="min-w-[300px] w-full max-w-[380px] mx-auto bg-white p-[15px]">
         <div class="w-full h-[56px] flex justify-between items-center py-[8px] px-[12px]">
            <h2 class="text-black !font-['Lato',sans-serif] font-normal text-[16px] tracking-[0.4px]"
               id="slide-over-title">Filter</h2>
            <div class="flex justify-center items-center h-[24px] w-[24px]">
               <button type="button"
                  class="text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 filter-close-btn"
                  @click="closeSlideCart">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
                        fill="#1D1B20" />
                  </svg>
               </button>
            </div>
         </div>
         <div class="w-full !mt-[20px] md:!mt-[30px] px-[12px]">
            <p class="text-black !font-['Lato',sans-serif] font-normal text-[14px] tracking-[0.4px]">Protein</p>
            <div class="!grid grid-cols-1  gap-2 mt-[20px]">
               <label v-for="(option, index) in sortedMealOptions" :key="index" :class="[
                'flex', 
                'items-center', 
                'justify-start',  
                'text-black', 
                'font-normal', 
                'sm:flex-1', 
                'text-[14px]',
                '!mb-0', 
                'focus:outline-none']">
                  <input type="checkbox" :name="'meal-option'" :value="option.value" class="!w-[16px] !h-[16px] !mr-[12px]"
                     :aria-labelledby="'meal-option-' + index + '-label'" v-model="option.checked"
                     :disabled="option.count==0">
                  <span :id="'meal-option-' + index + '-label'" class="text-[14px] !font-['Lato',sans-serif] font-normal">{{ option.label }} </span>
                  <span class="text-[14px] !font-['Lato',sans-serif] font-normal px-1">{{option.count }}</span>
               </label>
            </div>
         </div>
      </div>

      <div class="sticky !bottom-0 px-4 pb-3 bg-white sm:px-6 !hidden" @click="closeSlideCart">
         <div class="gap-4 pt-1 ">
            <a target="_self" class="block w-full" rel="noreferrer noopener">
               <button
                  class="flex items-center justify-center w-full px-6 py-3 text-base font-bold text-white border border-transparent rounded-md shadow-sm bg-[#005874] font-['Lato',sans-serif]">
                  <span>Close </span>
               </button>
            </a>
         </div>
      </div>
   </div>
</div>
      </div>
      <div class="border-b-[2px] border-b-[#F8F8F1] border-t-0    py-[15px] md:py-[20px] mt-[8px]" >
         <div class="flex gap-2 justify-between px-2 md:px-4">
            <h2 class="text-black my-auto !font-['Lato',sans-serif] font-semibold text-[18px] md:text-[24px] leading-[26px] tracking-[0.4px]" id="slide-over-title">
               Longevity Diet Meals
            </h2>
            <div class=" !hidden my-auto ">
               <div class="flex flex-wrap gap-2">
                  <div class="my-auto" v-for="option in checkedOptions" :key="option.id">
                     <div class="flex gap-2  my-auto whitespace-nowrap justify-center rounded-md hover:bg-gray-200 bg-gray-100 border  py-1 px-1 cursor-pointer ">
                        <span class="text-[12px] font-['Lato',sans-serif]">
                        {{ option.label }}
                        </span>
                        <span @click="toggleOption(option)" class="my-auto">
                           <svg width="5" height="5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.6 0L0 1.6L6.4 8L0 14.4L1.6 16L8 9.6L14.4 16L16 14.4L9.6 8L16 1.6L14.4 0L8 6.4L1.6 0Z" fill="black"></path>
                           </svg>
                        </span>
                     </div>
                  </div>
               </div>
            </div>
            <div class="w-[180px] my-auto  h-[40px] text-black !font-['Lato',sans-serif] !font-[600] !text-[14px] !leading-[18px] !tracking-[0.84px] flex justify-end pr-[5px] items-center gap-[16px] cursor-pointer filter-open-btn" @click="openSlideCart">
            <span class="tag-filter-count !px-[12px] !py-[4px] !rounded-full !bg-[#EF4E16] !text-white" v-if="checkedCount">{{checkedCount}}</span>
               FILTER 
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6C12 6.53043 12.2107 7.03914 12.5858 7.41421C12.9609 7.78929 13.4696 8 14 8C14.5304 8 15.0391 7.78929 15.4142 7.41421C15.7893 7.03914 16 6.53043 16 6M12 6C12 5.46957 12.2107 4.96086 12.5858 4.58579C12.9609 4.21071 13.4696 4 14 4C14.5304 4 15.0391 4.21071 15.4142 4.58579C15.7893 4.96086 16 5.46957 16 6M12 6H4M16 6H20M6 12C6 12.5304 6.21071 13.0391 6.58579 13.4142C6.96086 13.7893 7.46957 14 8 14C8.53043 14 9.03914 13.7893 9.41421 13.4142C9.78929 13.0391 10 12.5304 10 12M6 12C6 11.4696 6.21071 10.9609 6.58579 10.5858C6.96086 10.2107 7.46957 10 8 10C8.53043 10 9.03914 10.2107 9.41421 10.5858C9.78929 10.9609 10 11.4696 10 12M6 12H4M10 12H20M15 18C15 18.5304 15.2107 19.0391 15.5858 19.4142C15.9609 19.7893 16.4696 20 17 20C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18M15 18C15 17.4696 15.2107 16.9609 15.5858 16.5858C15.9609 16.2107 16.4696 16 17 16C17.5304 16 18.0391 16.2107 18.4142 16.5858C18.7893 16.9609 19 17.4696 19 18M15 18H4M19 18H20" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
         </div>
         <div class=" lg:hidden block my-3">
            <div class="flex flex-wrap px-4 gap-2 justify-center">
               <div class="my-auto" v-for="option in checkedOptions" :key="option.id">
                  <div class="flex gap-2  my-auto whitespace-nowrap justify-center rounded-md hover:bg-gray-200 bg-gray-100 border  py-1 px-1 cursor-pointer ">
                     <span class="text-[12px] font-['Lato',sans-serif]">
                     {{ option.label }}
                     </span>
                     <span @click="toggleOption(option)" class="my-auto">
                        <svg width="5" height="5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M1.6 0L0 1.6L6.4 8L0 14.4L1.6 16L8 9.6L14.4 16L16 14.4L9.6 8L16 1.6L14.4 0L8 6.4L1.6 0Z" fill="black"></path>
                        </svg>
                     </span>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div v-if="productNotFound" class="text-xl mt-6 md:mt-20 font-semibold text-center" >
         Products not found
      </div>
      <div class="px-4 py-[20px]">
         <div class="!grid grid-cols-2 lg:grid-cols-4 gap-4 !m-0 max-w-[100%] mx-auto">
            <div class="" v-for="item in filteredProducts" :key="item.id">
               <div  class="flex flex-col group cursor-pointer " style="background-color: #fff;border: 0;box-shadow: 0 0px #d0dede;">
                  <div class="min-w-[130px] portrait:max-w-[30%] min-h-[160px] lg:w-full object-cover relative rounded-[16px] overflow-hidden">
                     <img @click="selectedModal = item.id" :src="item.featured_image" class="min-w-[130px] portrait:max-w-[30%] min-h-[160px] square lg:w-full object-cover rounded-[16px] transition-transform duration-300 hover:scale-[1.05]" />

                     <div class="flex justify-end absolute bottom-0 left-0 w-full p-[18px]">
                        <div class="AddButton !bg-[#EF4E16] !h-[40px] !rounded-full !min-w-[93px] lg:hidden group-hover:block hover:!bg-[#BF3E11]" role="button" @click="addProduct(item)">
                            <div class="inline-flex items-center px-2 gap-[8px]">
                              <span class="text-[16px] font-medium">Add</span>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.0013 4.1665V15.8332M4.16797 9.99984H15.8346" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                        </div>
                      </div>
                     <div class="absolute  bottom-0 flex items-center justify-center left-0 bg-[#f7fc54] text-[.75rem] font-bold p-1"  
                        v-if="getTypeTagIfAvailable(item)"
                        v-html="getTypeTagIfAvailable(item)"
                        >
                     </div>
                  </div>
                  <div class="pt-[14px] pb-[20px]">
                     <div class="text-[#000000] text-[12px] leading-[1.3] font-['Lato',sans-serif]">
                        {{ item.vendor }} 
                     </div>
                     <div class="hidden"  :class="{'!block' : item.selling_plan_groups?.[0]?.selling_plans?.length==0}" > 
                        {{item.selling_plan_groups?.[0]?.selling_plans?.length}}
                     </div>
                     <p class="text-[18px] leading-[1.3] my-2 font-bold font-['Lato',sans-serif]" 
                        @click="selectedModal = item.id"
                        >
                        {{item.title}} 
                     </p>
                     
                  </div>
               </div>
               <div v-if="selectedModal == item.id">
                  <div
                     @click="selectedModal = -1"
                     class="fixed inset-0 bg-black/30 z-[99]"
                     ></div>
                  <div
                     class="fixed inset-0 flex items-center justify-center p-[15px] z-[100] max-w-[1390px] w-full mx-auto"
                     >
                     <div hyyy class="max-w-[1390px] w-full overflow-y-scroll max-h-[900px] mx-auto my-auto bg-white rounded-[32px]">
                        <div class="p-[15px] flex items-center justify-between">
                           <div class="w-full flex gap-[15px] items-center justify-end">
                              <span @click="selectedModal = -1" style="cursor: pointer; font-size: 18px; line-height: 1; color: black;">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M30 10L10 30M10 10L30 30" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </span>
                           </div>
                        </div>
                        <div class="flex flex-col md:flex-row justify-center px-[20px] md:px-[55px] gap-[30px] md:gap-[60px] pt-[25px] pb-[65px]">
                           <div class="modal-content-left w-full md:w-[50%]">
                              <div v-if="item.images && item.images.length > 0" class="w-full overflow-hidden">
                                 <!-- Main selected image -->
                                 <img :src="item.images[selectedImageIndex || 0]" class="w-auto mb-[16px] max-h-[520px] object-contain rounded-[16px] mx-auto" />
                                 <!-- Thumbnails when multiple images exist -->
                                 <div v-if="item.images.length > 1" class="flex flex-wrap gap-1 mt-2 ">
                                    <div
                                       v-for="(image, index) in item.images"
                                       :key="index"
                                       :style="{ 
                                       border: selectedImageIndex === index ? '2px solid #fd6d2e' : '1px solid #888888',
                                       width: '90px', 
                                       height: '90px',
                                       display: 'inline-block',
                                       cursor: 'pointer',
                                       padding: '1px',
                                       borderRadius: '2px',
                                       margin: '2px',
                                       borderRadius: '16px',
                                       }"
                                       @click="selectedImageIndex = index">
                                       <img
                                          :src="image"
                                          class="w-full h-full object-cover rounded-[16px]" />
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="modal-content-right w-full md:w-[50%] max-h-[660px] overflow-y-scroll bg-white" >
                              <span class="block text-[32px] md:text-[44px] font-medium leading-[1] mb-[15px] playfair-medium">{{item.title}}</span>
                              <div class="AddButton !bg-[#EF4E16] hover:!bg-[#BF3E11] !rounded-[8px] mb-[15px]" role="button" @click="addProduct(item); selectedModal = -1">
                                 <div class="inline-flex items-center">
                                    <span class="text-[16px] font-['Lato',sans-serif]">Add to Cart</span>
                                 </div>
                              </div>
                              <div class="!text-[14px]" v-html="item.description"></div>
                              
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="lg:hidden">
            <div class="fixed bottom-8 right-8 bg-[#f2f2f2] p-4 rounded-full shadow-lg z-[999]" @click="showSummary = true">
               <p class="absolute px-3 font-['Lato',sans-serif]">{{ totalQuantity }}</p>
               <svg xmlns="http://www.w3.org/2000/svg" width="31" height="25" viewBox="0 0 31 25"
                  class="">
                  <g fill="none" transform="translate(.593)">
                     <circle cx="20.5" cy="22.5" r="2" stroke="#333"></circle>
                     <circle cx="10.5" cy="22.5" r="2" stroke="#333"></circle>
                     <path fill="#333"
                        d="M3.333 5.5c.56 0 1.068.31 1.326.798l.059.125 4.23 10.154c.216.516.698.866 1.247.917l.138.006h10.293a1.5 1.5 0 0 0 1.343-.831l.057-.13.976-2.539h1.071l-1.113 2.897a2.498 2.498 0 0 1-2.152 1.596l-.182.007H10.333c-.95 0-1.812-.538-2.234-1.377l-.073-.161L3.795 6.808a.498.498 0 0 0-.377-.3L3.333 6.5H0v-1h3.333zM29.458 0l-4.615 12h-1.072l4.616-12h1.071z">
                     </path>
                  </g>
               </svg>
            </div>
         </div>
         <div v-if="showSummary">
            <div
               class="fixed inset-0 bg-black/30 z-[99]"
               ></div>
            <div
               class="fixed inset-0 flex items-center justify-center p-[15px] z-[100]"
               >
               <div class="max-w-[400px] max-h-[650px] mx-auto my-auto bg-white rounded-[16px]">
                  <div class="p-[15px] flex items-center justify-between">
                     <span class="font-['Lato',sans-serif]">Summary</span>
                     <div class="flex gap-[15px] items-center justify-end">
                        <span @click="showSummary = false" style="cursor: pointer; padding: 0px; border: 0px solid rgb(94, 94, 94); font-size: 18px; line-height: 1; color: black;">
                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 10L10 30M10 10L30 30" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </span>
                        
                     </div>
                  </div>
                  <div>
                     <div class="flex justify-center py-3">
                        <label class="m-0 px-4 font-['Lato',sans-serif]"> Your delivery frequency </label>
                        <select class="border-0 font-bold px-2 underline font-['Lato',sans-serif]"
                           v-model="delivery_type"
                           >
                           <option value="1"    > Every Week</option>
                           <option value="2" > Every Other Week</option>
                           <option value="4"   > Every Month</option>
                           <option value="one-time"   > One Time</option>
                        </select>
                     </div>
                     <div class="px-[10px]">
                        <div v-if="totalQuantity == total" role="button" class="CartFooter-btn !rounded-[8px]" @click="proceedNext()" :disabled="cartProcessing || totalQuantity < total">
                           <span v-if="cartProcessing" class="font-['Lato',sans-serif]">Loading...</span>
                           <span v-if="!cartProcessing" class="font-['Lato',sans-serif]">NEXT</span>
                        </div>
                        <div class="CartFooter-noticeText !hidden" v-if="totalQuantity == total">
                           <span class="flex items-center justify-center font-['Lato',sans-serif]">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                 viewBox="0 0 16 16">
                                 <path fill="#07872B"
                                    d="M13.445 4.113c0 .533-.242 1.053-.725 1.559l-.075.075-4.225 4.45c-.897.944-1.662 1.673-2.293 2.188-.631.515-1.077.772-1.336.772-.274 0-.613-.129-1.019-.386-.406-.257-.668-.523-.786-.796-.1-.228-.195-.711-.284-1.45a20.136 20.136 0 0 1-.133-2.399c0-.47.196-.904.588-1.302.392-.399.825-.598 1.299-.598.45 0 .72.412.806 1.237l.02.212c.074.633.158 1.075.254 1.326.095.25.225.376.39.376.068 0 .195-.074.382-.222.187-.148.41-.35.67-.605l4.34-4.3a6.34 6.34 0 0 1 .978-.827c.287-.187.531-.28.732-.28.15 0 .257.057.321.17.064.114.096.306.096.575v.225z">
                                 </path>
                              </svg>
                              All Set!
                           </span>
                        </div>
                     </div>
                     <div class="overflow-y-scroll max-h-[450px] px-[.5rem] mb-[15px]">
                        <div v-for="(item, i) in selected"
  class="flex justify-between gap-[12px] bg-white py-[12px] mx-[20px] min-w-[300px] w-[300px] lg:w-[calc(100% - 2rem)] relative"
    :style="i !== selected.length - 1 ? 'border-bottom: 2px solid rgb(248, 248, 241);' : ''">
  <figure class="flex items-center w-full m-0 gap-[12px]">
    <img :src="item.featured_image" class="inline-block w-[72px] h-[72px] rounded-[8px]" />
    <div class="flex flex-col flex-1">
      <h2 class="uppercase m-0"
        style="font-family: Lato, sans-serif; font-weight: 700; font-size: 14px; line-height: 1rem; letter-spacing: 1.4px; color: rgb(51, 51, 51);">
        {{ item.title }}
      </h2>
    </div>
  </figure>
  <div class="flex lg:flex-col lg:items-center bg-[#F8F8F1] rounded-[8px]">
    <div class="inline-block w-[28px] h-[28px] bg-transparent hover:bg-[#faf9f8]"
      >
      <div class="CartItem-btn add"
        style="font-weight: 400;font-size: 30px;line-height: 1rem;letter-spacing: normal;color: #01596e;">
      </div>
    </div>
    <p>{{ item.quantity }}</p>
    <div class="inline-block w-[28px] h-[28px] bg-transparent hover:bg-[#faf9f8]"
      >
      <div class="CartItem-btn remove"
        style="font-weight: 400;font-size: 30px;line-height: 1rem;letter-spacing: normal;color: #666;"></div>
    </div>
  </div>
</div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="w-[344px] min-w-[344px] flex flex-col lg:h-[calc(100vh-90px)] lg:sticky lg:top-[105px] border-t-[0px] border-[#d9d9d9] mt-[15px]" style="border-left: 1px solid #fff;">
      <div class="flex justify-between min-h-[48px] py-[15px] md:py-[15px] items-center px-[20px] bg-[#fff] sticky top-[0px] z-[10]" 
         style="border: 0px solid #f2f2f2;">
         <div class="flex justify-between min-h-[40px] items-center w-full">
          <p class="font-medium text-[16px]">Choose Meals</p>
          <p class="font-medium text-[16px]">{{ totalQuantity }}/{{ total }}</p>
         </div>
        <p class=" !hidden" style="font-family: 'Lato', sans-serif;font-weight: 400;font-size: .875rem;line-height: 1rem;letter-spacing: normal;color: #333;"> Estimated Delivery Date<br/>
        <b class=" !hidden">{{ formattedDate(showingDeliveryDate) }}</b>
        </p>
        <div class="clear-all-button !hidden font-['Lato',sans-serif]" @click="selected = []">Clear All</div>
      </div>
      <div class="lg:max-h-[600px] relative flex lg:flex-grow lg:overflow-scroll mb-[30px] lg:mb-0">
         <ul class="pt-[15px] flex lg:block mb-[7px] w-[100vw] lg:w-full overflow-x-scroll">
            <li v-for="(item, i) in selected" class="mb-[0.25em] group">
               <div
                  class="flex justify-between gap-[12px] bg-white py-[12px] mx-[20px] min-w-[300px] w-[300px] lg:w-[calc(100% - 2rem)] relative"
                  :style="i !== selected.length - 1 ? 'border-bottom: 2px solid rgb(248, 248, 241);' : ''">
                  <figure class="flex items-center w-full m-0 gap-[12px]">
                     <img :src="item.featured_image" class="inline-block w-[72px] h-[72px] rounded-[8px]"
                        style="" />
                     <div class="flex flex-col flex-1">
                        <h2 class="uppercase m-0"
                           style="font-family: 'Lato', sans-serif;font-weight: 700;font-size: 14px; line-height: 1rem;letter-spacing: 1.4px;color: #333;">
                           {{ item.title }}
                        </h2>
                     </div>
                  </figure>
                  <div class="hidden lg:flex lg:flex-col lg:items-center bg-[#F8F8F1] rounded-[8px]">
                     <div role="button" class="inline-block w-[28px] h-[28px] bg-transparent hover:bg-[#faf9f8]"
                        @click="addProduct(item)">
                        <div class="CartItem-btn add w-full h-full flex items-center justify-center">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 0.5V7.5M0.5 4H7.5" stroke="#081112" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                     </div>
                     <p class="font-['Lato',sans-serif]">{{ item.quantity }}</p>
                     <div role="button" class="inline-block w-[28px] h-[28px] bg-transparent hover:bg-[#faf9f8]"
                        @click="removeProduct(item)">
                        <div class="CartItem-btn remove w-full h-full flex items-center justify-center">
                          <svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 0.5H7.5" stroke="#081112" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                     </div>
                  </div>
               </div>
            </li>
         </ul>
      </div>
      <div role="button" class="pb-[44px] relative pt-[28px] px-[20px] bg-[#fff] rounded-t-[16px] border-t-[2px] border-t-[#F8F8F1]" style="">
         <div class="absolute top-0 left-[50%] !hidden" style="transform: translate(-50%,-50%);">
            <div
               style="position: absolute;width: 72px;height: 24px;pointer-events: none;border: 1px solid #f2f2f2;border-bottom: none;border-top-left-radius: 24px;border-top-right-radius: 24px;">
            </div>
            <button class="mb-[30px] flex w-[72px] h-[48px] py-[10px] px-[5px] bg-[#faf9f8]"
               style="font-size: .875rem;border: none;border-radius: 0;outline: none;">
               <section style="position: relative;bottom: 4px;left: 18px;width: 15px;color: #01596e;">
                  <aside class="flex flex-col" style="transform: translateY(-50%);">
                     <span style="opacity: 0;">{{ totalQuantity }}</span>
                     <span style="opacity: 1;">{{ totalQuantity }}</span>
                  </aside>
               </section>
               <svg xmlns="http://www.w3.org/2000/svg" width="31" height="25" viewBox="0 0 31 25"
                  class="absolute left-[15px]">
                  <g fill="none" transform="translate(.593)">
                     <circle cx="20.5" cy="22.5" r="2" stroke="#333"></circle>
                     <circle cx="10.5" cy="22.5" r="2" stroke="#333"></circle>
                     <path fill="#333"
                        d="M3.333 5.5c.56 0 1.068.31 1.326.798l.059.125 4.23 10.154c.216.516.698.866 1.247.917l.138.006h10.293a1.5 1.5 0 0 0 1.343-.831l.057-.13.976-2.539h1.071l-1.113 2.897a2.498 2.498 0 0 1-2.152 1.596l-.182.007H10.333c-.95 0-1.812-.538-2.234-1.377l-.073-.161L3.795 6.808a.498.498 0 0 0-.377-.3L3.333 6.5H0v-1h3.333zM29.458 0l-4.615 12h-1.072l4.616-12h1.071z">
                     </path>
                  </g>
               </svg>
               <p class="relative bottom-[3px] left-[27px] text-[12px] text-[#333] font-['Lato',sans-serif]">{{ total }}</p>
               <div class="absolute bottom-0 left-[28px] w-[16px] h-[1px] " style="border: 1px solid #f2f2f2;"></div>
            </button>
         </div>
         <div>
            <div class="flex flex-col justify-between w-full">
               <p class="m-0 pl-[10px]  text-[12px] font-['Lato',sans-serif]">How many meals </p> 
               <select
                  class="border-[#EBEBE4] font-normal px-2 underline pr-[20px] rounded-[6px] h-[40px] mt-[6px] font-['Lato',sans-serif]"
                  v-model="selectedProductHandle"
                  @change="updateMealSelection"  >
                  <option 
                     v-for="product in mealBoxProducts" 
                     :key="product.handle" 
                     :value="product.handle"
                     >
                     {{ formatMealOption(product) }}
                  </option>
               </select>
            </div>
            <div class="flex flex-col justify-between w-full mt-[12px]">
               <p class="m-0 pl-[10px] text-[12px] font-['Lato',sans-serif]"> Deliver </p>
               <select class="border-[#EBEBE4] font-normal px-2 underline pr-[20px] rounded-[6px] h-[40px] mt-[6px] block font-['Lato',sans-serif]"
                  v-model="delivery_type"  >
                  <option value="1"    > Every Week</option>
                  <option value="2" > Every Other Week</option>
                  <option value="4"   > Every Month</option>
                  <option value="one-time"   > One Time</option>
               </select>
            </div>
            <div class="flex flex-col justify-between w-full mt-[12px]">
               <p class="m-0 pl-[10px] text-[12px] font-['Lato',sans-serif]"> Estimated Delivery Date </p>
               <p class="pl-[10px] font-normal text-[16px] font-['Lato',sans-serif]">{{ formattedDate(showingDeliveryDate) }}</p>
            </div>
            <div role="button" class="CartFooter-btn mt-[18px] !h-[44px] !rounded-[8px]" @click="proceedNext()" :disabled="cartProcessing || totalQuantity < total">
               <span v-if="cartProcessing" class="font-['Lato',sans-serif]">Loading...</span>
               <span v-if="!cartProcessing" class="font-['Lato',sans-serif]">NEXT</span>
            </div>
            <div class="CartFooter-noticeText !hidden" v-if="totalQuantity == total">
               <span class="flex items-center justify-center font-['Lato',sans-serif]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                     viewBox="0 0 16 16">
                     <path fill="#07872B"
                        d="M13.445 4.113c0 .533-.242 1.053-.725 1.559l-.075.075-4.225 4.45c-.897.944-1.662 1.673-2.293 2.188-.631.515-1.077.772-1.336.772-.274 0-.613-.129-1.019-.386-.406-.257-.668-.523-.786-.796-.1-.228-.195-.711-.284-1.45a20.136 20.136 0 0 1-.133-2.399c0-.47.196-.904.588-1.302.392-.399.825-.598 1.299-.598.45 0 .72.412.806 1.237l.02.212c.074.633.158 1.075.254 1.326.095.25.225.376.39.376.068 0 .195-.074.382-.222.187-.148.41-.35.67-.605l4.34-4.3a6.34 6.34 0 0 1 .978-.827c.287-.187.531-.28.732-.28.15 0 .257.057.321.17.064.114.096.306.096.575v.225z">
                     </path>
                  </svg>
                  All Set!
               </span>
            </div>
         </div>
      </div>
   </div>
   <div></div>
</div>
<div class="Checkout-tab">
<div class="pt-[40px] md:pt-[78px] relative flex justify-start flex-col items-start gap-[20px]"
  v-if="currentTab == 'Checkout'">
  <div class="w-full mx-auto max-w-[1500px] xl:px-[40px] px-[10px] xl:absolute">
    <ol class="flex w-full justify-start gap-4">
      <li class="!m-0">
        <a href="#"
          class="text-[#666] !font-['Lato',sans-serif]  text-[16px] flex gap-[8px] justify-center items-center"
          @click="currentTab = 'Meals'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 6L9 12L15 18" stroke="#18181C" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>

          Back to Cart</a>
      </li>
      <!-- <li class="!m-0">
        <a href="#" class="text-[#666] text-[1.125rem] leading-[1.125rem] tracking-normal font-extrabold">Checkout</a>
      </li> -->
    </ol>
  </div>

  <div class="w-full mx-auto max-w-[920px] px-[20px]">
    <div class="cart__page flex flex-col md:flex-row gap-[60px] md:flex-nowrap">
      <div class="cart__page-col max-w-[455px] w-full mx-auto">
        <div class="cart__item !hidden" data-key="32740376051797:0a249cfccdacd08fe88b69286edcfa59">
          <div class="cart__image"><a style="height: 0px; padding-bottom: 100%;"><img class="lazyautosizes lazyloaded"
                data-widths="[180, 360, 540]" data-aspectratio="true" data-sizes="auto"
                :src="customMainProductVariant?.featured_image?.src"></a>
          </div>
          <div class="cart__item-details">
            <div class="cart__item-title"><a class="cart__item-name">Pick Your Own Plan </a>
              <div class="cart__item--variants"></div>

              <div class="meals-per-week">Meals Per Week:&nbsp;10</div>
              <div class="product_type">Product Type : <span class="product_type capitalize">{{product_type}}</span>
              </div>
              <div class="delivery-type">Delivery : <span class="delivery_type capitalize">{{delivery_type_text}}</span>
              </div>
              <div class="ship-date">Ship Date:&nbsp;{{ formattedDate(cartData?.attributes["Ship Date"]) }}</div>
            </div>
            <div class="cart__item-sub">
              <div>
                <div class="js-qty__wrapper"><label
                    for="cart_updates_32740376051797:0a249cfccdacd08fe88b69286edcfa59-page"
                    class="hidden-label">Quantity</label><input type="text"
                    id="cart_updates_32740376051797:0a249cfccdacd08fe88b69286edcfa59-page" name="updates[]"
                    class="js-qty__num !px-[8px]" value="1" min="0" pattern="[0-9]*"
                    data-id="32740376051797:0a249cfccdacd08fe88b69286edcfa59" disabled=""></div><br>
              </div>
              <div class="cart__item-price-col text-right"><span class="cart__price">{{ "$" }}{{
                  cartData.items_subtotal_price / 100 }}</span></div>
            </div>
          </div>
        </div>
        <p class="w-full text-start text-[18px] md:text-[24px] font-bold !font-['Lato',sans-serif]">
          Order Summary </p>
        <hr class="no-b">
        <div class="cart__item flex justify-center items-center" v-for="item in selected" :key="item.id">
          <div class="cart__image">
            <img class="lazyautosizes lazyloaded w-[72px] h-[72px] object-cover rounded-[8px]"
              data-widths="[180, 360, 540]" data-aspectratio="true" data-sizes="auto"
              alt="Nicoyan Tomatillo Salsa with N4L Rainbow Patty" :data-srcset="item.featured_image" sizes="150px"
              :srcset="item.featured_image">
          </div>
          <div class="cart__item-title"><a class="cart__item-name !font-['Lato',sans-serif]"
              style="font-weight: 700; font-size: 14px; line-height: 1rem; letter-spacing: 1.4px; color: rgb(51, 51, 51);">{{
              item.title }}</a>
            <div class="cart__item--variants"></div>

          </div>
          <div class="cart__item-sub">
            <div>
              <div class="js-qty__wrapper"><label class="hidden-label">Quantity</label><input type="text"
                  name="updates[]" class="js-qty__num !px-[8px]" :value="item.quantity" min="0" pattern="[0-9]*"
                  disabled="">
              </div><br>
            </div>
            <div class="cart__item-price-col text-right"><span class="cart__price">$0.00</span></div>
          </div>
        </div>

        <hr class="no-b">
        <div v-if="show_olive_upsell">
          <div v-if="show_olive_upsell && !added_upsell"
            class="bg-white border border-gray-200 flex flex-col items-start md:flex-row rounded-lg shadow"><img
              class="md:h-auto object-cover w-[350px]" src="/cdn/shop/products/OliveOil_720x.png?v=1679339285" alt="">
            <div class="flex flex-col justify-between leading-normal p-4">
              <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">2 x Organic Polyphenol
                Rich Olive Oil</h5>
              <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">
              <ul class="list-disc mt-5 pl-8">
                <li>Premium Extra Virgin Centenarian Olive Oil</li>
                <li>From Bosana and Coratina Olive Cultivars in Sardinia Italy</li>
                <li>Gently Cold Pressed and unfiltered to preserve superior polyphenol levels</li>
                <li>250ml (8.5fl oz) Product of Italy</li>
                <li>USDA Organic cert</li>
                <li>Certified by control body authorized by Suolo e Salute</li>
              </ul>
              <p class="font-bold mt-3 text-3xl">
                <s class="text-gray-400">$45</s> $25
              </p>
              <button type="button" name="add" class="btn mt-5" @click.prevent="addUpsell(40733892378709, 2)">

                <span v-if="adding_upsell">Adding...</span>
                <span v-else>Add to cart</span>
              </button></p>
            </div>
          </div>
          <div v-else class="cart__item">
            <div class="cart__image"><a style="height: 0px; padding-bottom: 100%;"><img
                  src="/cdn/shop/products/OliveOil_720x.png?v=1679339285"></a></div>
            <div class="cart__item-details">
              <div class="cart__item-title"><a class="cart__item-name">Organic Polyphenol Rich Olive Oil</a>
                <div class="cart__item--variants"></div>
              </div>
              <div class="cart__item-sub">
                <div>
                  <div class="js-qty__wrapper" data-form-type="other"><label class="hidden-label">Quantity</label><input
                      type="text" name="updates[]" class="js-qty__num !px-[8px]" min="0" value="2" pattern="[0-9]*"
                      disabled="" data-form-type="other"></div><br>
                </div>
                <div class=""><span class="cart__price">$25</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h-[100vh] w-[1px] bg-[#d9d9d9] hidden md:block"></div>
      <div class="white-background max-w-[305px] w-full mx-auto">
        <div data-discounts="true"></div>
        <div class="cart__item-sub cart__item-row !mb-[30px] md:!mb-[44px]">
          <div class="w-full !m-0">
            <span class="block text-[12px] !font-['Lato',sans-serif]">Scheduled delivery date</span>
            <span class="block font-bold text-[16px] !font-['Lato',sans-serif] mt-[10px]">{{
              formattedDateWithDay(showingDeliveryDate) }}</span>
          </div>
        </div>

        <div class="cart__item-sub cart__item-row">
          <div class="block font-regular text-[16px] !font-['Lato',sans-serif]">Delivery</div>
          <div class="block font-bold text-[16px] !font-['Lato',sans-serif]">{{delivery_type_text}}</div>
        </div>

        <div class="cart__item-sub cart__item-row">
          <div class="block font-regular text-[16px] !font-['Lato',sans-serif]">Meal Count</div>
          <div class="block font-bold text-[16px] !font-['Lato',sans-serif]">{{ total }}</div>
        </div>

        <div class="cart__item-sub cart__item-row">
          <div class="block font-regular text-[16px] !font-['Lato',sans-serif]">Subtotal</div>
          <div class="block font-bold text-[16px] !font-['Lato',sans-serif]" data-subtotal="true">{{ "$" }}{{
            cartData.items_subtotal_price / 100 }}</div>
        </div>


        <div class="cart__item-row cart__checkout-wrapper !my-[40px] !cursor-pointer" @click="checkout">
          <a name="checkout"
            class="btn cart__checkout !rounded-[8px] h-[44px] !font-['Lato',sans-serif] !font-[600] !text-[16px] !normal-case hover:!bg-[#BF3E11] !cursor-pointer !h-[44px] !tracking-wide"
            style="visibility: visible;">Checkout</a>
        </div>
        <div class="cart__item-row text-start !font-['Lato',sans-serif]">
          <small class="!mb-[12px]"> <span class="!font-['Lato',sans-serif]" style="font-size: 12px; line-height: 14px;">Tax, shipping,
              &amp; discounts applied in checkout.</span> </small>

          <small class="!font-['Lato',sans-serif] !mb-[12px]" v-if="delivery_type != 'one-time'"> SKIP, PAUSE
            OR CANCEL ANY TIME</small><small><span style="font-size: smaller; color: rgb(49, 49, 49);">After
              completing this order, you will be notified via email each week to modify, skip, pause, or
              cancel your order before your cutoff. See our <a href="/pages/faqs" target="_blank">FAQs</a> for
              additional details. </span></small>

        </div>
      </div>
    </div>
  </div>

</div>
    </div>
    `,
    data() {
      return {
        slideCartOpen: false,
        selectedmeal: "Low Carb",
        mealOptions: [
          { label: "Vegan", value: "Vegan" },
          { label: "Chicken", value: "Chicken" },
          { label: "Turkey", value: "Turkey" },
          { label: "Vegetarian", value: "Vegetarian" },
          { label: "Fish", value: "Fish" },
          { label: "Beef", value: "Beef" },
          { label: "Shellfish", value: "Shellfish" },
          { label: "Pork", value: "Pork" },
          { label: "Egg", value: "Egg" },
        ], 
        currentTab: "Meals",
        selected: store.state.selected,
        products: store.state.products,
        qParams: window.location.search,
        params: [],
        show_olive_upsell: false,
        adding_upsell: false,
        added_upsell: false,
        deliveryDate: null,
        showingDeliveryDate: null,
        cartProcessing: false,
        customData: null,
        oneTimeProduct: null,
        cartData: null,
        grouped: null,
        selectedModal: -1,
        selectedImageIndex: 0,
        showSummary: false,
        delivery_type: "one-time",
        how_many_meals: "10",
        mealBoxProducts: [],
        selectedProductHandle: "futurhealth-10-meal-box",
      };
    },
    methods: {
      toggleOption(option) {
        option.checked = false;
      },
      optioncheckednames() {
        return this.checkedOptions.map((option) => option.label).join(", ");
      },
      openSlideCart() {
        this.slideCartOpen = true;
      },
      closeSlideCart() {
        this.slideCartOpen = false;
      },
      getParemeterByName(name) {
        // let url = window.location.search;
        // let params = url.split("?")[1].split("&");
        // let param = params.filter((p) => p.includes(name))[0];
        // if (!param) return null;

        // param = param.split("=")[1];
        //removehash
        return '';
      },
      async addUpsell(variantId, quantity) {
        this.adding_upsell = true;
        await this.addVariantToCart(variantId, quantity);
        this.adding_upsell = false;
        this.added_upsell = true;
        //this.show_olive_upsell = false;
        this.getCartData();
      },
      formattedDate(date) {
        let dateObj;
        if (typeof date === "string") {
          dateObj = new Date(date);
        } else {
          dateObj = date;
        }

        return moment(dateObj.toISOString().split("T")[0], "YYYY-MM-DD").format(
          "DD MMMM YYYY",
        );
      },
      formattedDateWithDay(date) {
        let dateObj;
        if (typeof date === "string") {
          dateObj = new Date(date);
        } else {
          dateObj = date;
        }

        return moment(dateObj.toISOString().split("T")[0], "YYYY-MM-DD").format(
          "dddd, DD MMMM YYYY",
        );
      },
      addProduct(item) {
        if (this.totalQuantity < this.total) {
          const existingItem = this.selected.find(
            (element) => element.id === item.id,
          );

          if (existingItem) {
            // If the item exists, increase the quantity by one.
            existingItem.quantity++;
          } else {
            // If the item does not exist, add the item with quantity set to 1.
            this.selected.push({ ...item, quantity: 1 });
          }
        } else {
          this.showSummary = true;
        }
      },
      async addVariantToCart(variantId, quantity) {
        let properties = {
          shipping_interval_unit_type: "Weeks",
          shipping_interval_frequency: "1",
          charge_on_day_of_week: "4",
        };
        if (this.delivery_type == "2") {
          properties["shipping_interval_frequency"] = "2";
        } else if (this.delivery_type == "4") {
          properties["shipping_interval_frequency"] = "1";
          properties["shipping_interval_unit_type"] = "Months";
        }

        const props = {
          items: [
            {
              quantity: quantity,
              id: variantId,
              properties,
            },
          ],
        };

        const body = JSON.stringify(props);
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body,
        });
        const data = await response.json();

        return data;
      },
      removeProduct(item) {
        const selectedItem = this.selected.find(
          (element) => element.id === item.id,
        );
        if (selectedItem) {
          // Ensure quantity is greater than 0 before decreasing.
          if (selectedItem.quantity > 1) {
            selectedItem.quantity--;
          } else {
            // Remove the item if its quantity is 0 or less.
            const index = this.selected.indexOf(selectedItem);
            if (index !== -1) {
              this.selected.splice(index, 1);
            }
          }
        }
      },
      getCartData() {
        axios.get(`/cart.js`).then((res) => {
          this.cartData = res.data;
        });
      },
      async proceedNext() {
        try {
          let MAX_ALLOWED_SELECTION = this.total;

          if (this.totalQuantity != this.total) {
            alert(`Please select all ${this.total} items to continue.`);
            return;
          }

          this.cartProcessing = true;
          let properties = {
            //shipping_interval_unit_type: "Weeks",
            //  shipping_interval_frequency: "1",
            charge_on_day_of_week: "4",
          };
          if (this.delivery_type == "bi-weekly") {
            // properties["shipping_interval_frequency"] = "2";
          } else if (this.delivery_type == "monthly") {
            // properties["shipping_interval_frequency"] = "1";
            // properties["shipping_interval_unit_type"] = "Months";
          }

          let currentWeekday = dayjs().day();
          if (currentWeekday >= 4) {
            let wednesdayThisWeek = dayjs().day(3);
            let NextChargeDate = wednesdayThisWeek.add(2, "week");
            let diffDays = NextChargeDate.diff(dayjs(), "day"); // 20214000000 default milliseconds
            console.log("wednesdayThisWeek :>> ", wednesdayThisWeek);
            console.log("currentWeekday :>> ", currentWeekday);
            console.log("diffDays :>> ", diffDays);
            properties["first_recurring_charge_delay"] = diffDays;
          }

          let selling_plans =
            this.customMainProduct.selling_plan_groups?.[0]?.selling_plans?.find(
              (e) => e.name.toLowerCase().includes(this.delivery_type),
            );
          let mainSellingPlanId = selling_plans?.id;
          if (this.delivery_type == "one-time") {
            properties = {};
            mainSellingPlanId = null;
          } else {
            if (!mainSellingPlanId) {
              alert("Selling Plan not found");
              return;
            }
          }
          let mainVariantId = this.customMainProductVariant?.id;
          if (!mainVariantId) {
            alert("Product variant not found. Please try again.");
            this.cartProcessing = false;
            return;
          }
          let items = [
            {
              id: mainVariantId,
              selling_plan: mainSellingPlanId,
              quantity: 1,
              properties: {
                "Ship Date": this.deliveryDate,
                "Meals Per Week": MAX_ALLOWED_SELECTION,
                ...properties,
              },
            },
          ];

          this.selected.forEach((i) => {
            let selling_planId =
              i.selling_plan_groups?.[0]?.selling_plans?.find((e) =>
                e.name.toLowerCase().includes(this.delivery_type),
              )?.id;
            if (this.delivery_type == "one-time") {
              selling_planId = null;
            } else {
              if (!selling_planId) {
                alert("Selling Plan not found");
                return;
              }
            }

            items.push({
              id: i.variants[0].id,
              selling_plan: selling_planId,
              quantity: i.quantity,
              properties,
            });
          });

          let data = {
            items,
          };

          console.log("DATA: ", data);

          await axios.post(`/cart/clear.js`, {});
          await axios.post(`/cart/add.js`, data);
          await axios.post(`/cart/update.js`, {
            attributes: {
              "Ship Date": this.deliveryDate,
            },
          });

          this.currentTab = "Checkout";
          console.log("CURRENT TAB: ", this.currentTab);
          
          this.grouped = _.groupBy(this.selected, (item) => item.id);
          console.log("GROUPED: ", this.grouped);
          axios.get(`/cart.js`).then((res) => {
            this.cartData = res.data;
          });
        } catch (e) {
          console.log("Error: ", e);
          let error = e?.response?.data?.description;
          if (!error) error = e.message;

          alert(error);
        } finally {
          this.cartProcessing = false;
        }
      },
      getDeliveryDate(selectedDeliveryDay) {
        dayjs.extend(dayjs_plugin_weekday);
        let todayDate = dayjs();
        if (todayDate.day() < 5) {
          todayDate = todayDate.add(1, "day");
        }
        let TodayDayOfweek = todayDate.day();
        let AllowedDays = [1]; //MONDAY NOW // Wednesday and Friday;
        let possibleDeliveryDay = TodayDayOfweek + 3;
        //    let selectedDeliveryDay = 5; //
        let StartNextWeek = false;
        if (possibleDeliveryDay > 5) {
          StartNextWeek = true;
        }
        let DeliveryDay;
        if (possibleDeliveryDay < selectedDeliveryDay) {
          DeliveryDay = dayjs().weekday(selectedDeliveryDay);
        } else if (TodayDayOfweek > 3) {
          DeliveryDay = dayjs().weekday(selectedDeliveryDay).add(2, "week");
        } else {
          DeliveryDay = dayjs().weekday(selectedDeliveryDay).add(1, "week");
        }

        return DeliveryDay;
      },
      checkout() {
        console.log(`CHECKING OUT...!`);
        let event = new Event("one_page_store_checkout", {
          bubbles: true,
        });
        if (this.delivery_type == "one-time") {
          location.href = "/checkout";
          _learnq.push(["track", "one-time-checkout"]);
        } else {
          document.dispatchEvent(event);
        }
      },
      formatMealOption(product) {
        if (!product) return '';
        
        // Extract meal count from title
        const mealMatch = product.title.match(/(\d+)/);
        const mealCount = mealMatch ? mealMatch[1] : '10';
        
        // Get price from first variant
        const price = product.variants && product.variants[0] ? 
          (product.variants[0].price / 100).toFixed(2) : '0.00';
         
        return `${mealCount} Meals - $${price}`;
      },
      updateMealSelection() {
        const selectedProduct = this.mealBoxProducts.find(
          (p) => p.handle === this.selectedProductHandle
        );
        if (selectedProduct) {
          // Extract meal count from title or handle
          const mealMatch = selectedProduct.title.match(/(\d+)/);
          if (mealMatch) {
            this.how_many_meals = mealMatch[1];
          }
        }
      },
      getTypeTagIfAvailable(product) {
        let tags = product.tags;
        if (!product.tags) return null;
        if (!Array.isArray(tags)) return null;
        let typeTag = tags.find((tag) => tag.includes("type_"));
        if (typeTag) {
          return `<span >
              {typeTag.replace("type_", "")}
            </span>`;
        } else if (product.tags.includes("Breakfast")) {
          return `<span >
              Breakfast
            </span>`;
        }

        return null;
      },
    },
    computed: {
      delivery_type_text() {
        if (this.delivery_type == "1") {
          return "Every week";
        } else if (this.delivery_type == "2") {
          return "Every Other Week";
        } else if (this.delivery_type == "4") {
          return "Every Month";
        }
        return "One Time";
      },
      totalQuantity() {
        return this.selected.reduce((acc, item) => acc + item.quantity, 0);
      },
      total() {
        return parseInt(this.how_many_meals);
      },
      customMainProductVariant() {
        
        if (!this.customMainProduct || !this.customMainProduct.variants) {
          return null;
        }
        console.log("customMainProduct: from customMainProductVariant ", this.customMainProduct);
        // For meal box products, just return the first variant (or the appropriate one)
        if (this.selectedProductHandle && this.mealBoxProducts.length > 0) {
          // Return the first available variant for the selected meal box product
          return this.customMainProduct.variants[0];
        }
        
        // Legacy logic for old product structure
        let howManyMeals = this.total;
        let price = this.getParemeterByName("price");
        let source = this.product_type?.toLowerCase();
        let variant = this.customMainProduct.variants.find((i) => {
          return (
            i.option2 && i.option2.toLowerCase().includes(source) &&
            i.option1 && i.option1.includes(howManyMeals)
          );
        });

        return variant || this.customMainProduct.variants[0];
      },
      product_type() {
        let source = this.getParemeterByName("product_type");
        return source || "Custom Meal Plan";
      },
      meals_per_week() {
        return this.total || "10";
      },

      customMainProduct() {
        // Return the selected meal box product from mealBoxProducts
        const selectedProduct = this.mealBoxProducts.find(
          (p) => p.handle === this.selectedProductHandle
        );
        console.log("customMainProduct: from customMainProduct ", selectedProduct);

        if (selectedProduct) {
          return selectedProduct;
        }
        // Fallback to customData if meal box products not loaded
        return this.customData;
      },
      filteredProducts() {
        if (this.mealOptionsNew) {
          return this.products.filter((product) => { 
            return this.mealOptionsNew.every((option) => {
              if (option.checked) {
                return product.tags.includes(option.value.toLowerCase());
              }
              return true;
            });
          });
        }
        return this.products;
      },
      productNotFound() {
        return this.filteredProducts.length === 0 && this.products.length > 0;
      },
      mealOptionsNew() {
        let options = this.mealOptions;
        options = options.map((option) => {
          option.count = this.products.filter((product) => {
            product.tags = product.tags.map((tag) => tag.toLowerCase());
            return product.tags.includes(option.value.toLowerCase());
          });
          option.count = option.count.length;
          return option;
        });

        return options;
      },
      selectedMealLabel() {
        const selectedOption = this.mealOptions.find(
          (option) => option.value === this.selectedmeal,
        );
        return selectedOption ? selectedOption.label : "";
      },
      filteredProductCount() {
        return this.filteredProducts.length;
      },
      checkedOptions() {
        return this.mealOptions.filter((option) => option.checked);
      },
      checkedCount() {
        return this.mealOptions.filter((option) => option.checked).length;
      },
      sortingcheckedCount() {
        return this.sortingOptions.filter((option) => option.checked).length;
      },
      sortedMealOptions() {
        return this.mealOptionsNew.slice().sort((a, b) => b.count - a.count);
      },
    },
    mounted() {
      document.addEventListener("one_page_store_checkout", function (event) {
        _learnq.push(["track", "pick-your-own-completed"]);
        $(".cart__checkout").addClass("btn--body loading");
        //window.reChargeProcessCart();
        location.href = "/checkout";
        console.log("Checkout Event called.");
      });
      // ESC key handler for closing modals
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          if (this.selectedModal !== -1) {
            this.selectedModal = -1;
          }
          if (this.showSummary) {
            this.showSummary = false;
          }
          if (this.slideCartOpen) {
            this.slideCartOpen = false;
          }
        }
      });
    },
    components: {},
    created() {
      // store.getProducts();
      this.deliveryDate = this.getDeliveryDate(2);
      this.showingDeliveryDate = this.getDeliveryDate(2);
      axios
        .get(`/collections/retail-meals?view=custom-collection-json`)
        // changes 28-oct
        // .get(
        //   `/collections/general-wellness?view=custom-collection-json`
        // )
        .then((res) => {
          console.log(res);
          if (res.data && res.data.products) {
            this.products = res.data.products;
          }
        });

      // Fetch meal box products
      const mealBoxHandles = ['futurhealth-7-meal-box', 'futurhealth-10-meal-box'];
      Promise.all(
        mealBoxHandles.map(handle => 
          axios.get(`/products/${handle}?view=custom-meta`)
        )
      ).then((responses) => {
        this.mealBoxProducts = responses.map(res => res.data.product).filter(Boolean);
        console.log("Meal Box Products: ", this.mealBoxProducts);
        // Set initial how_many_meals based on default selected product
        this.updateMealSelection();
      }).catch((error) => {
        console.error("Error fetching meal box products:", error);
      });

      axios
        .get(`/products/futurhealth-10-meal-box`)
        .then((res) => {
          console.log("Custom DATA: ", res);
          this.customData = res.data.product;
        });
      axios
        .get(
          `/products/longevity-diet-pick-your-own-plan-one-time?view=custom-meta`,
        )
        .then((res) => {
          console.log("Custom DATA: ", res);
          this.oneTimeProduct = res.data.product;
        });
    },
    watch: {
      totalQuantity(oldQuantity, newQuantity) {
        setTimeout(() => {
          let qty = this.totalQuantity;

          if (qty == this.total) {
            this.showSummary = true;
          }
        }, 100);
      },
    },
  }).mount("#meals-checkout-app");
}

//   <div className="pt-4 px-4">
//   <p><strong>Need a Bulk Order for your Department? </strong>Please call our client engagement team at <strong>973-970-9063. </strong>We require a 2-week lead time.</p>
//    <p class="mt-2 bg-[#fe6c2f] text-left text-white text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] font-semibold py-2 px-4" >
//    Longevity Diet meals are temporarily out of stock. Please check back later to place your order - or Call: 1(973) 970-9063.
//  </p>
//   </div>
